import { Component, OnInit } from '@angular/core';
import { faCrosshairs } from '@fortawesome/free-solid-svg-icons';
import { MapService } from '../../../../../../shared/services/map.service';
import { LocalStorageService } from '../../../../../../shared/services/local-storage.service';

@Component({
  selector: 'app-pref-position',
  templateUrl: './pref-position.component.html',
  styleUrls: ['./pref-position.component.scss']
})
export class PrefPositionComponent implements OnInit {
  faCrosshair = faCrosshairs;

  // Liste des positions préconfigurées avec coordonnées et zoom
  locations = [
    { name: 'MAP.POSITION.LOCATIONS.FRANCE', coords: [2.5159, 47.4], zoom: 6 },
    { name: 'MAP.POSITION.LOCATIONS.GUADELOUPE', coords: [-61.551, 16.265], zoom: 9 },
    { name: 'MAP.POSITION.LOCATIONS.MARTINIQUE', coords: [-61.024, 14.6415], zoom: 9 },
    { name: 'MAP.POSITION.LOCATIONS.MAYOTTE', coords: [45.166, -12.8275], zoom: 10 },
    { name: 'MAP.POSITION.LOCATIONS.SOUTH_AFRICA', coords: [18.51348115798356, -34.02805939722654], zoom: 9 },
    { name: 'MAP.POSITION.LOCATIONS.REUNION', coords: [55.5364, -21.1151], zoom: 10 }
  ];

  selectedLocation: any = null; 

  constructor(
    private mapService: MapService, 
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    // Récupération de la position sauvegardée
    const savedLocationName = localStorage.getItem('selectedLocation');
    if (savedLocationName) {
      const savedLocation = this.locations.find(location => location.name === savedLocationName);
      if (savedLocation) {
        this.selectedLocation = savedLocation;
      }
    }
    if (!this.selectedLocation) {
      this.selectedLocation = this.locations[0];
      this.saveSelectedPosition();
    }
  }

  saveSelectedPosition() {
    if (this.selectedLocation) {
      const currentMapPreference = {
        lat: this.selectedLocation.coords[1],
        lng: this.selectedLocation.coords[0],
        zoom: this.selectedLocation.zoom
      };
  
      this.localStorageService.saveMapPreferences(currentMapPreference);
      localStorage.setItem('selectedLocation', this.selectedLocation.name);
  
      this.mapService.setMapPosition([currentMapPreference.lng, currentMapPreference.lat], currentMapPreference.zoom);
    }
  }

  saveCurrentPosition() {
    const currentMapPreference = this.mapService.getCurrentMapPosition();
    if (currentMapPreference) {
      this.localStorageService.saveMapPreferences(currentMapPreference);
    } else {
      console.error('Impossible de récupérer la position actuelle de la carte');
    }
  }
}
